export default "__VITE_ASSET__Broe14xk__"